import { UPDATE_FEE_RATES } from "./action";

export const initialState = {
  Fast: '',
  Normal: '',
  Slow: ''
};
export default function feeRateReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FEE_RATES:
      return { ...action.data };
    default:
      return state;
  }
}